// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_ob-5";
export var filledCircle = "_ob-4";
export var historyEntry = "_ob-3";
export var messageSideLeft = "_ob-1";
export var messageSideRight = "_ob-2";
export var orderTrackingCarouselWrapper = "_ob-6";
export var orderTrackingInfoContainer = "_ob-0";